<template>
  <div>
    <PartnerHeader :img_header="header_image" header="เพิ่มข่าวสารใหม่" link_back="newsinformation"/>
    <MenuPartner/>
    <News_add/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/news.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import News_add from "@/components/admin/manage_pos/news_store_setting/News_add";
export default {
  name: "NewsAdd",
  components: {
    News_add,
    // MenuPartner,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
